(function () {
    'use strict';

    // --- Configuration ---
    const DBG = false; // Set to false to disable logging
    function log(...args) { if (DBG) console.log('[hdt-fix-atc]', ...args); }
    function err(...args) { if (DBG) console.error('[hdt-fix-atc]', ...args); }

    // --- Helper: Find quantity input robustly ---
    function findQuantityInput(form, btn) {
        // Method 1: Inside form
        let qtyInput = form?.querySelector('[name="quantity"]');
        if (qtyInput) {
            log('Found quantity inside form:', qtyInput.value);
            return qtyInput.value;
        }

        // Method 2: External by form attribute
        if (form?.id) {
            qtyInput = document.querySelector(`input[name="quantity"][form="${form.id}"]`);
            if (qtyInput) {
                log('Found quantity by form attribute:', qtyInput.value);
                return qtyInput.value;
            }
        }

        // Method 3: Look in parent section (same ancestor container)
        const section = btn?.closest('.shopify-section') || btn?.closest('[data-section-id]') || btn?.closest('section');
        if (section) {
            qtyInput = section.querySelector('input[name="quantity"].hdt-quantity__input');
            if (qtyInput) {
                log('Found quantity in section:', qtyInput.value);
                return qtyInput.value;
            }
            // Also try without the class
            qtyInput = section.querySelector('input[name="quantity"]');
            if (qtyInput) {
                log('Found quantity in section (any):', qtyInput.value);
                return qtyInput.value;
            }
        }

        // Method 4: Look in hdt-quantity-wrapp near the button
        const productInfo = btn?.closest('.hdt-main-product, .hdt-product-info, .hdt-product');
        if (productInfo) {
            qtyInput = productInfo.querySelector('hdt-quantity-wrapp input[name="quantity"]');
            if (qtyInput) {
                log('Found quantity in product info:', qtyInput.value);
                return qtyInput.value;
            }
        }

        // Method 5: Fallback - look for any visible quantity input on page
        const allQtyInputs = document.querySelectorAll('input[name="quantity"].hdt-quantity__input');
        for (const input of allQtyInputs) {
            if (input.offsetParent !== null) { // visible check
                log('Found visible quantity input:', input.value);
                return input.value;
            }
        }

        log('No quantity input found, defaulting to 1');
        return 1;
    }

    // --- Shared Add to Cart Logic ---
    function addToCart(variantId, quantity, btn) {
        if (!variantId) {
            err('No variant ID found');
            return;
        }

        // Add loading state
        if (btn) btn.classList.add('is-loading');

        // Add spinner if missing
        if (btn && !btn.querySelector('.hdt-loading__spinner')) {
            const spinner = document.createElement('span');
            spinner.className = 'hdt-loading__spinner hdt-absolute';
            spinner.innerHTML = '<svg width="16" height="16" class="hdt-svg-spinner" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="hdt-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
            btn.appendChild(spinner);
            spinner.hidden = false;
        } else if (btn) {
            const spinner = btn.querySelector('.hdt-loading__spinner');
            if (spinner) spinner.hidden = false;
        }

        // Prepare Payload
        const formData = {
            'items': [{
                'id': Number(variantId),
                'quantity': Number(quantity || 1)
            }]
        };

        // Construct Valid URL - Always use relative path to avoid domain issues
        const addUrl = '/cart/add.js';

        // Fetch
        fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
            .then(r => r.json())
            .then(data => {
                if (data.status === 422) {
                    err('Add to cart failed (422):', data.description);
                    // alert(data.description); // Disabled as per request
                    return;
                }
                log('Item added. Updating drawer...');
                updateCartDrawer(true);
            })
            .catch(error => {
                err('Fetch error:', error);
            })
            .finally(() => {
                if (btn) {
                    btn.classList.remove('is-loading');
                    const spinner = btn.querySelector('.hdt-loading__spinner');
                    if (spinner) spinner.hidden = true;
                }
            });
    }

    // --- Form Submit Handler (Product Pages) ---
    function handleFormSubmit(e) {
        const form = e.target;
        // Check if it's likely a cart add form
        const action = form.getAttribute('action');
        if (!action || !action.includes('/cart/add')) return;

        log('Intercepted form submit:', form);

        // STOP EVERYTHING - prevent default form submission
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('button[type="submit"]');

        // Extract Data
        let variantId = form.querySelector('[name="id"]')?.value;
        // Use robust quantity finder
        let quantity = findQuantityInput(form, btn);

        addToCart(variantId, quantity, btn);
    }

    // --- Button Click Handler (Collection Pages) ---
    function handleButtonClick(e) {
        const btn = e.target.closest('[data-hdt-add-to-cart][data-product-id]');
        if (!btn) return;

        log('Intercepted button click:', btn);

        // Prevent any default behavior
        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.getAttribute('data-product-id');
        const quantity = btn.getAttribute('data-quantity') || 1;

        addToCart(variantId, quantity, btn);
    }

    // --- Drawer Update Logic ---
    function updateCartDrawer(openDrawer) {
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const url = (rootUrl === '/') ? '/?section_id=cart-drawer' : rootUrl.replace(/\/$/, '') + '/?section_id=cart-drawer';

        fetch(url)
            .then(r => r.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newDrawer = doc.querySelector('#CartDrawer');
                const currDrawer = document.getElementById('CartDrawer');
                if (newDrawer && currDrawer) {
                    currDrawer.innerHTML = newDrawer.innerHTML;
                }

                // Update Counts
                const selectors = ['[data-cart-count]', '.hdt-cart-count', '.hdt-cart-number'];
                selectors.forEach(sel => {
                    const newEls = doc.querySelectorAll(sel);
                    const currEls = document.querySelectorAll(sel);
                    if (newEls.length && currEls.length) {
                        currEls.forEach((el, i) => {
                            if (newEls[i]) {
                                el.textContent = newEls[i].textContent;
                                if (parseInt(el.textContent) > 0) el.classList.remove('hdt-hidden');
                            }
                        });
                    }
                });

                // Dispatch Events
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

                // Open Drawer
                if (openDrawer && currDrawer) {
                    currDrawer.removeAttribute('hidden');
                    currDrawer.setAttribute('open', '');
                    currDrawer.classList.remove('hdt-hidden');

                    // Try to call show method if available
                    if (typeof currDrawer.show === 'function') {
                        try { currDrawer.show(); } catch (e) { }
                    }
                }
            })
            .catch(error => {
                err('Cart drawer update error:', error);
            });
    }

    // --- Universal Interaction Handler ---
    function handleInteraction(e) {
        const btn = e.target.closest('[data-hdt-add-to-cart]');
        if (!btn) return;

        log('Intercepted interaction:', e.type, btn);

        // STOP EVERYTHING
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Check if inside a product form
        const form = btn.closest('form[action*="/cart/add"]');

        let variantId, quantity;

        if (form) {
            // Extract variant from form
            variantId = form.querySelector('[name="id"]')?.value;
            // Use robust quantity finder
            quantity = findQuantityInput(form, btn);
        } else {
            // Extract from button attributes (Collection/Quick Add)
            variantId = btn.getAttribute('data-product-id');
            quantity = btn.getAttribute('data-quantity') || 1;
        }

        addToCart(variantId, quantity, btn);
    }

    // --- Initializer ---
    function init() {
        log('Initializing Add to Cart Interceptor');

        // 1. Capture form submissions (Fallback)
        document.addEventListener('submit', function (e) {
            const form = e.target;
            const action = form.getAttribute('action');
            if (action && action.includes('/cart/add')) {
                // If we missed the click, catch the submit
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                // Reuse logic similar to interactive handler
                const btn = form.querySelector('[type="submit"][name="add"]');
                let variantId = form.querySelector('[name="id"]')?.value;
                // Use robust quantity finder
                let quantity = findQuantityInput(form, btn);
                addToCart(variantId, quantity, btn);
            }
        }, true);

        // 2. Capture ALL interactions on our buttons (Click & Touch)
        // This blocks the theme's click listeners
        ['click', 'touchend'].forEach(evt => {
            document.addEventListener(evt, handleInteraction, { capture: true, passive: false });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
